@if (!isDataSourceLoading) {
  <dx-drop-down-box
    [(value)]="selectedIds"
    valueExpr="id"
    displayExpr="name"
    [showClearButton]="false"
    [dataSource]="dataSource"
    id="{{ 'dropDownBox' + dropDownBoxId }}"
    (onOpened)="onDropdownOpened()"
    (onClosed)="onDropdownClosed()"
    [disabled]="isDisabled"
    [placeholder]="getPlaceHolder()"
    #dropDownBox
    >
    <dxo-drop-down-options>
      <dxo-position
        [my]="position.my"
        [at]="position.at"
        [offset]="position.offset"
        collision="flip"
        of="{{ '#dropDownBox' + dropDownBoxId }}"
        >
      </dxo-position>
    </dxo-drop-down-options>
    <div *dxTemplate="let data of 'content'">
      <div class="row center-center search-row" >
        <i class="rif-search search-box__ri-icon" [ngClass]="{'dropDownGridIncludedInTitleSearchBoxIcon': this.isIncludedInTitle}"></i>
        <input
          class="item grow search-box"
          [ngClass]="{'dropDownGridIncludedInTitleSearchBox': this.isIncludedInTitle}"
          placeholder="{{ 'Shell.generic.search' | translate | uppercase }}"
          #searchBox
          />
        </div>
        @if (isMultiselect) {
          <div class="row select-all-container">
            @if (!justSomeValuesSelected) {
              <dx-check-box [(value)]="selectAllChecked"></dx-check-box>
            }
            @if (justSomeValuesSelected) {
              <dx-check-box [disabled]="!canSelectAll" [(value)]="undefinedBoolean"></dx-check-box>
            }
            @if (!filtered) {
              <div class="select-all">{{ "Shell.generic.selectAll" | translate | uppercase }}</div>
            }
            @if (filtered) {
              <div class="select-all">{{ "Shell.generic.selectFiltered" | translate | uppercase }}</div>
            }
          </div>
        }
        <dx-data-grid
          class='dropDownGrid'
          [ngClass]="{'dropDownGridIncludedInTitle': this.isIncludedInTitle}"
          keyExpr="id"
          [dataSource]="dataSource"
          [columns]="columns"
          [selection]="selectionMode"
          (onSelectionChanged)="onSelectionChanged()"
          [hoverStateEnabled]="true"
          [paging]="{ enabled: false }"
          [scrolling]="{ mode: 'standard' }"
          [(selectedRowKeys)]="selectedIds"
          [showColumnHeaders]="false"
          [showRowLines]="false"
          #dropDownGrid
          id="{{ popupId }}"
          [height]="calculateDropDownDataGridHeight()"
          >
        </dx-data-grid>
        @if (showButtons) {
          <div class="buttons-container">
            <button
              class="button-secondary filter-button"
              type="button"
              (click)="onOK()"
              >
              {{ "Shell.generic.ok" | translate | uppercase }}
            </button>
            <button
              class="button-secondary filter-button"
              type="button"
              (click)="onCancel()"
              >
              {{ "Shell.generic.cancel" | translate | uppercase }}
            </button>
          </div>
        }
      </div>
      <dx-validator [validationRules]="validationRules"></dx-validator>
    </dx-drop-down-box>
  }
  @if (isDataSourceLoading) {
    <dx-text-box
      value="{{ 'Shell.generic.loading' | translate | uppercase }}"
      [disabled]="true"
      >
    </dx-text-box>
  }
